/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Mock_VerifiedInputs */

const en_cp_mock_verified = /** @type {(inputs: Cp_Mock_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verified tasks`)
};

const id_cp_mock_verified = /** @type {(inputs: Cp_Mock_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task terverifikasi`)
};

/**
* | output |
* | --- |
* | "Verified tasks" |
*
* @param {Cp_Mock_VerifiedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_mock_verified = /** @type {((inputs?: Cp_Mock_VerifiedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Mock_VerifiedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_mock_verified(inputs)
	return en_cp_mock_verified(inputs)
});